import(/* webpackMode: "eager", webpackExports: ["ProjetsBoostSection"] */ "/vercel/path0/src/app/projets/_components/projets-boost-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSectionScroll"] */ "/vercel/path0/src/components/sections/home-section-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioPreviewSection"] */ "/vercel/path0/src/components/sections/portfolio-preview-section.tsx");
